export default __webpack_public_path__ + "static/media/host_naviTodo_active.19ca8a4a.svg";